import React from 'react'
import { Collapse as CollapseBase, Container as ContainerBase, Grid as GridBase, styled } from '@mui/material'
import { Close as CloseBase } from '@mui/icons-material'

export const Root = styled('div')`
  height: 1px;
  position: relative;
  width: 100%;
`

export const Backdrop = styled('div')`
  background-color: ${props => props.theme.palette.gray[50.5]};
  height: ${props => props.height}px;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 1;
`

export const Panel = styled(CollapseBase)`
  &.MuiCollapse-root {
    background-color: ${props => props.theme.palette.brand.white};
    border-top: 1px solid ${props => props.theme.palette.brand.gray1};
    height: ${props => (props.open ? '208px' : '0')};
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 100;
  }
`

export const Content = styled(ContainerBase)`
  &.MuiContainer-root {
    padding: 32px 24px 48px;
  }
  ${props => props.theme.breakpoints.up('sm')} {
    &.MuiContainer-root {
      padding: 48px 98px;
    }
  }
`

export const Row = styled(props => <GridBase container {...props} />)``

export const Form = styled('form')`
  width: 100%;
`

export const Column = styled(({ textAlign, ...props }) => <GridBase item {...props} />)`
  &.MuiGrid-item {
    text-align: ${props => props.textAlign || 'initial'};
  }
`

export const Title = styled('span')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 22px;
  line-height: 26px;
  margin: 0 0 15px;
`

export const CloseIcon = styled(CloseBase)`
  &.MuiSvgIcon-root {
    cursor: pointer;
    fill: ${props => props.theme.palette.brand.black3};
    font-size: 2rem;
  }
`

export const Text = styled('p')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 16px;
  line-height: 20px;
  margin: 0 0 27px;
`
